module.exports = __webpack_public_path__ + "img/aerial-view-woman-using-retro-typewriter.13f98a99.jpg";